export const CREATE_PATIENT = "CREATE_PATIENT";
export const CREATE_PATIENT_LOADING = "CREATE_PATIENT_LOADING";
export const CREATE_PATIENT_FAILED = "CREATE_PATIENT_FAILED";

export const RESET_CREATE_PATIENT_MESSAGE = "RESET_CREATE_PATIENT_MESSAGE";

export const FETCH_CRITERIA_LIST = "FETCH_CRITERIA_LIST";
export const FETCH_CRITERIA_LIST_LOADING = "FETCH_CRITERIA_LIST_LOADING";
export const FETCH_CRITERIA_LIST_FAILED = "FETCH_CRITERIA_LIST_FAILED";

export const FETCH_LOCATIONS = "FETCH_LOCATIONS";
export const FETCH_LOCATIONS_FAILED = "FETCH_LOCATIONS_FAILED";

export const UPDATE_LOCATION_IDS = "UPDATE_LOCATION_IDS";

export const FETCH_CALLBACK_PATIENTS_LOADING =
  "FETCH_CALLBACK_PATIENTS_LOADING";
export const FETCH_CALLBACK_PATIENTS = "FETCH_CALLBACK_PATIENTS";
export const FETCH_CALLBACK_PATIENTS_FAILED = "FETCH_CALLBACK_PATIENTS_FAILED";

export const FETCH_COMPLETED_PATIENTS_LOADING =
  "FETCH_COMPLETED_PATIENTS_LOADING";
export const FETCH_COMPLETED_PATIENTS = "FETCH_COMPLETED_PATIENTS";
export const FETCH_COMPLETED_PATIENTS_FAILED =
  "FETCH_COMPLETED_PATIENTS_FAILED";

export const FETCH_TESTS_PATIENTS_LOADING = "FETCH_TESTS_PATIENTS_LOADING";
export const FETCH_TESTS_PATIENTS = "FETCH_TESTS_PATIENTS";
export const FETCH_TESTS_PATIENTS_FAILED = "FETCH_TESTS_PATIENTS_FAILED";

export const FETCH_PATIENT_SUMMARY = "FETCH_PATIENT_SUMMARY";
export const FETCH_PATIENT_SUMMARY_LOADING = "FETCH_PATIENT_SUMMARY_LOADING";
export const FETCH_PATIENT_SUMMARY_FAILED = "FETCH_PATIENT_SUMMARY_FAILED";

export const FETCH_LOCATION_FROM_BED = "FETCH_LOCATION_FROM_BED";
export const FETCH_LOCATION_FROM_BED_LOADING =
  "FETCH_LOCATION_FROM_BED_LOADING";
export const FETCH_LOCATION_FROM_BED_FAILED = "FETCH_LOCATION_FROM_BED_FAILED";

export const FETCH_COMMENTS = "FETCH_COMMENTS";
export const FETCH_COMMENTS_FAILED = "FETCH_COMMENTS_FAILED";
export const FETCH_COMMENTS_LOADING = "FETCH_COMMENTS_LOADING";

export const DELETE_COMMENTS = "DELETE_COMMENTS";
export const DELETE_COMMENTS_FAILED = "DELETE_COMMENTS_FAILED";
export const DELETE_COMMENTS_LOADING = "DELETE_COMMENTS_LOADING";

export const UPDATE_SUMMARY = "UPDATE_SUMMARY";
export const UPDATE_SUMMARY_FAILED = "UPDATE_SUMMARY_FAILED";
export const UPDATE_SUMMARY_LOADING = "UPDATE_SUMMARY_LOADING";

export const REVERT_SUMMARY = "REVERT_SUMMARY";
export const REVERT_SUMMARY_FAILED = "REVERT_SUMMARY_FAILED";
export const REVERT_SUMMARY_LOADING = "REVERT_SUMMARY_LOADING";
